<template>
  <div class="Main-Inner">
    <div class="Main-Content">
      <Page
        :title="$t('Campaigns')"
        :primaryAction="{
          label: $t('New Campaign'),
          onAction: createCampaign,
          disabled: saving
        }"
      >

        <LoadingLayout v-if="loading" />
        <template v-else>

          <Layout>
            <LayoutSection>
              <Card>
                <Tabs
                  :tabs="[
                    { id: '', label: $t('All') },
                    { id: 'draft', label: $t('Drafts') },
                    { id: 'scheduled', label: $t('Scheduled') },
                    { id: 'running', label: $t('Currently Running') },
                    { id: 'finished', label: $t('Finished') },
                    { id: 'trashed', label: $t('Trash') },
                  ]"
                  v-model="filterStatus"
                />
                <template v-if="campaigns.length">
                  <campaign-list-box
                    v-if="filterStatus === 'draft' || !filterStatus && filteredCampaignDrafts.length"
                    :heading="$t('Drafts')"
                    :campaigns="filteredCampaignDrafts"
                    :buttonsDisabled="saving"
                    @set-saving="(value) => saving = value"
                    @edit="edit">
                  </campaign-list-box>
                  <campaign-list-box
                    v-if="filterStatus === 'scheduled' || !filterStatus && filteredCampaignScheduled.length"
                    :heading="$t('Scheduled')"
                    :campaigns="filteredCampaignScheduled"
                    :buttonsDisabled="saving"
                    @set-saving="(value) => saving = value"
                    @edit="edit">
                  </campaign-list-box>
                  <campaign-list-box
                    v-if="filterStatus === 'running' || !filterStatus && filteredCampaignRunning.length"
                   :heading="$t('Currently Running')"
                   :campaigns="filteredCampaignRunning"
                   :buttonsDisabled="saving"
                   @set-saving="(value) => saving = value"
                   @edit="edit">
                  </campaign-list-box>
                  <campaign-list-box
                    v-if="filterStatus === 'finished' || !filterStatus && filteredCampaignFinished.length"
                    :heading="$t('Finished')"
                    :campaigns="filteredCampaignFinished"
                    :buttonsDisabled="saving"
                    @set-saving="(value) => saving = value"
                    @edit="edit">
                  </campaign-list-box>
                  <campaign-list-box
                    v-if="filterStatus === 'trashed' || !filterStatus && filteredCampaignTrash.length"
                    :heading="$t('Trash')"
                    :campaigns="filteredCampaignTrash"
                    :buttonsDisabled="saving"
                    @set-saving="(value) => saving = value"
                    @edit="edit">
                  </campaign-list-box>
                </template>
                <template v-else>
                  <CardSection>
                    {{ $t('No Campaigns') }}
                  </CardSection>
                </template>
              </Card>
            </LayoutSection>
          </Layout>

        </template>
      </Page>
    </div>

  </div>
</template>

<script>

import CampaignListBox from '../components/CampaignListBox'

export default {
  name: 'Campaigns',
  data() {
    return {
      loading: true,
      saving: false,
      campaigns: [],
      filterStatus: 'running'
    }
  },
  created() {
    // guard
    if (!this.theUser.hasCampaignAccess) {
      this.$router.replace({ name: 'Insights' })
    }
  },
  async mounted() {
    this.eventHub.$on('updateCampaignData', () => {
      this.load()
    })
    this.load()
  },
  beforeDestroy() {
    this.eventHub.$off('updateCampaignData')
  },
  methods: {
    load() {
      NProgress.start()
      this.api.getCampaigns()
        .then((response) => {
          this.campaigns = response || []
          this.loading = false

          if (this.$refs.filter) {
            this.$refs.filter.focus()
          }
        })
        .catch(this.apiCatch) 
        .finally(()=> {
          NProgress.done()
        })
    },
    edit(id) {
      this.$router.push(`/campaigns/${id}/details/`)
    },
    validateName(newName) {
      if (newName && newName.trim()) {
        const sameNameCampaign = this.campaigns.filter(camp => {
          return camp.name === newName.trim()
        })
        if (!sameNameCampaign.length) {
          return true
        }
      }
      return false
    },
    async createCampaign() {
      const newName = await this.$ui.prompt({
        title: this.$t('Create Campaign'),
        content: this.$t('Enter New Campaign Name'),
        primaryActionLabel: this.$t('Create'),
        inputPlaceholder: this.$t('Campaign Name')
      })
      if (this.validateName(newName)) {
        this.saving = true
        NProgress.start()
        this.api.createCampaign(newName)
          .then((response) => {
            this.$router.push('/campaigns/' + response)
          })
          .catch(this.apiCatch)
          .finally(() => {
            this.saving = false
            NProgress.done()
          })
      } else if (newName && newName.trim()) {
        this.$ui.alert({
          title: this.$t('Alert'),
          content: this.$t('campaignEdit.warning.Campaign name already exists')
        })
      }
    }
  },
  computed: {
    filteredCampaigns() {
      let data = this.campaigns
      if (this.filterStatus) {
        data = data.filter(c => c.status === this.filterStatus)
      }
      return data
    },
    filteredCampaignDrafts() {
      return this.campaigns.filter(c => c.status === 'draft')
    },
    filteredCampaignScheduled() {
      return this.campaigns.filter(c => c.status === 'scheduled')
    },
    filteredCampaignRunning() {
      return this.campaigns.filter(c => c.status === 'running')
    },
    filteredCampaignFinished() {
      return this.campaigns.filter(c => c.status === 'finished')
    },
    filteredCampaignTrash() {
      return this.campaigns.filter(c => c.status === 'trashed')
    },
  },
  components: {
    CampaignListBox
  }
}
</script>
